module.exports = __webpack_public_path__ + "static/media/book-with-glasses.4f969830.svg";